<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='regain'" ref="refForm" :model="modalInfo"
				:label-width="120">
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col :span="24">
					<FormItem label="订单编号" prop="StartTime">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.OrderNo" placeholder="订单编号"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem label="充电开始时间" prop="StartTime">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.StartTime" placeholder="充电开始时间"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem label="充电结束时间" prop="EndTime">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.EndTime" placeholder="充电结束时间"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col :span="12">
					<FormItem label="充电时长(秒)" prop="ChargeDuration">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.ChargeDuration" placeholder="充电时长"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem label="充电电量(度))" prop="ChargeKwh">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.ChargeKwh" placeholder="充电电量"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col :span="12">
					<FormItem label="充电费用(元)" prop="ChargeCost">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.ChargeCost" placeholder="充电费用"></Input>
					</FormItem>
					</Col>
					<Col :span="12">
					<FormItem label="优惠金额(元)" prop="CouponAmount">
						<Input :disabled="modal.canInput" :readonly="true" v-model="modalInfo.CouponAmount" placeholder="优惠金额"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='regain'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk('regain')">结算</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('输入运营商Id'));
				} else {
					if (this.modalInfo.OperatorId.length !== 9) {
						callback(new Error('输入社会信用代码码第9~倒数第2位'));
					}
					callback();
				}
			};
			return {
				modal: {
					Title: "订单恢复",
					type: "regain",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				modalInfo: {
					OrderNo: '',
					StartTime: '',
					EndTime: '',
					ChargeDuration: '',
					ChargeKwh: '',
					ChargeCost: '',
					CouponAmount: '',
					HasChargeInfo: false,
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				/******分割线********/
				//校验字段
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					Name: [{
						required: true,
						message: '控件名称',
						trigger: 'blur'
					}],
					Display: [{
						required: true,
						message: '显示名称',
						trigger: 'blur'
					}],
					Icon: [{
						required: true,
						message: '图标',
						trigger: 'blur',
					}],
				},
			};
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				switch (type) {
					case "regain":
						_this.modal.Title = "手动结算";
						_this.modal.type = "regain";
						_this.getRegain(params)
						break;
					default:
						break;
				}
				_this.modal.ifShow = true
			},
			getRegain: function(OrderNo) {
				const _this = this;
				const parms = {
					OrderNo: OrderNo,
				}
				_this.$axios.post(webapi.base_api_url + "/Order/GetRecoveryOrderInfo", parms, {}).then(res => {
					console.log("获得恢复订单信息")
					console.log(res.data)
					if (res.data.Code == 0) {
						// _this.$emit('handleSubmit');
						// _this.modalOk("cancle")
						_this.modalInfo = {
							OrderNo: OrderNo,
							StartTime: res.data.Data.StartTime,
							EndTime: res.data.Data.EndTime,
							ChargeDuration: res.data.Data.ChargeDuration,
							ChargeKwh: res.data.Data.ChargeKwh,
							ChargeCost: res.data.Data.ChargeCost,
							CouponAmount: res.data.Data.CouponAmount,
							HasChargeInfo: true
						};
					} else {
						_this.modalInfo = {
							OrderNo: parms.OrderNo,
							StartTime: '',
							EndTime: '',
							ChargeDuration: '',
							ChargeKwh: '',
							ChargeCost: '',
							CouponAmount: '',
							HasChargeInfo: false
						};
						this.$Message.warning(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'regain':
						if (_this.modalInfo.HasChargeInfo) {
							_this.regain();
						} else {
							_this.$Modal.confirm({
								title: "确认结算？",
								content: '无充电信息，是否直接结算？',
								okText: '取消',
								cancelText: '确定',
								onCancel: () => {
									_this.regain();
								}
							});
						}
						break;
					default:
						break;
				}
			},
			regain: function() {
				const _this = this;
				let parms = _this.modalInfo
				_this.$axios.post(webapi.base_api_url + "/Order/OrderRecovery", parms, {}).then(res => {
					console.log("手动结算")
					if (res.data.Code == 0) {
						this.$Message.success('手动结算成功');
						_this.$emit('handleSubmit');
						_this.modalOk("cancle")
					} else {
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
		},
		mounted() {
		},
		computed: {
		}
	}
</script>

<style>
</style>
